import { IEnvironmentFromFile } from './environment.types'
import { FEATURE_FLAGS_PROD as FEATURE_FLAGS } from './feature-flags'
import { SERVICE_URLS_PROD as SERVICE_URLS } from './service-urls'

export const environmentProd: IEnvironmentFromFile = {
  ...FEATURE_FLAGS,
  ...SERVICE_URLS,

  // KEYS
  ADOBE_DTM: 'launch-EN4b0cc1c046db4a3da7308feed4637416.min',
  AUTH0_AUTH_KEY:
    'oxford-user:https://auth.cinch.co.uk:B5XFE1dV7b8IMpeZxY8kqCPOPiAwgwD7',
  SEGMENT_KEY: 'fxuC9PcNxIbVcTp5QHTWYF9QggSg3Mvs',
  AUTH0_CLIENT_ID: 'B5XFE1dV7b8IMpeZxY8kqCPOPiAwgwD7',
  CINCH_CHARGE_CARD_REQUEST_API_KEY: 'R48mFOTC6BamHbg1LR8k97fvGXOBOweg1PsHdERV',
  LOGISTICS_FULFILMENT_SERVICE_API_KEY:
    'vHY5ZQAdbm3yu8suHQb6c7vXsnfxWBjR4OD7r6bi',
  STRIPE_PUBLISHABLE_KEY: 'pk_live_3rDkEJzP58ZdTSIqCDS7XoAy00NjjZYQGR',
  CUSTOMER_DATA_API_KEY: '141271a4-f574-41de-9eee-962ee2674d80',
  GOOGLE_GEOCODING_API_KEY: 'AIzaSyByDk23cR4OsdocVq2YuwRVr_mGs-ABrs8',
  STORE_AVAILABILITY_KEY: 'eLjNp74jG51yIGqe8NTOS11U6UWd9axB8AumFuXi',
  SITES_API_KEY: 'IQAulZAr4f5mHavrXzZDA9ZHI6Ln75MN9oGel6rk',
  PROPOSAL_SUBMISSION_API_KEY: '04KS2uUH2b1dy1r7ztQqaGforFOFdQp4vVazxmxg',
  FEATURE_FLAG_API_KEY: 'ORTwjHNfEy2iCxUqD3s6I3Lzm6XZ2sqX3vGFXXWR',
  IDEAL_POSTCODES_API_KEY: 'ak_kdejaxrppYWZNgyl3pLl03aueGKgp',

  // EXPERIMENT IDS
  NAVBAR_VALUATION_EXPERIMENT_ID: 'value-my-car-cta',
  AI_SEARCH_EXPERIMENT_ID: 'ai-search',

  // CONSTS
  SEARCH_CHANNEL_ID: 'CINCH',
  AUTH0_DATABASE_NAME: 'Username-Password-Authentication',
  PROMO_BANNER_NAME: 'sale',
  ADMIN_FEE_VALUE: '9900',
  UNSUBSCRIBE_MINIMUM_DURATION: '3000',
  FINANCE_SDD_PDF: 'Cinch_SDD_v03.pdf',
  FINANCE_COMMISSION_PDF: 'commissionV9.pdf',
  REPRESENTATIVE_APR_USED_CAR: '12.4',
}
